import { Route, Switch, RouteProps as IRouteProps, Redirect } from 'react-router'
import loadable from '@loadable/component'

const HomePage = loadable(() => import('../pages/Home'))

const routes: IRouteProps[] = [
  {
    path: '/',
    exact: true,
    render() {
      return <Redirect from="/" to="/products" />
    },
  },
  {
    path: '/home',
    exact: true,
    component: HomePage,
  },
  {
    path: '/products',
    exact: true,
    component: HomePage,
  },
  {
    path: '/products-test',
    exact: true,
    component: HomePage,
  },
  {
    path: '/user-manual/:key',
    component: loadable(() => import('../pages/UserManual')),
  },
  {
    path: '/product/:key',
    component: loadable(() => import('../pages/Product')),

  },
  {
    path: '/smartScreenFaq/:key',
    component: loadable(() => import('../pages/SmartScreenFaq')),

  },
  {
    path: '/smartScreenTips',
    component: loadable(() => import('../pages/UsageTips')),
  },
  {
    path: '/smartArticle/:key',
    component: loadable(() => import('../pages/SmartArticle')),
  },
  {
    path: '/article/:key',
    component: loadable(() => import('../pages/Article')),
  },
  {
    path: '/articleGrouping/:key',
    component: loadable(() => import('../pages/ArticleGroupingKey')),
  },
  {
    path: '/module/:key/videos',
    component: loadable(() => import('../pages/Videos')),
  },
  {
    path: '/module/:key/user-manuals',
    component: loadable(() => import('../pages/UserManuals')),
  },
  {
    path: '/search',
    exact: true,
    component: loadable(() => import('../pages/Search')),
  },
]

export default function Routes() {
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route {...route} key={route.path?.toString() || index} />
      ))}
    </Switch>
  )
}
